import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import { IListPrice } from "@/interfaces/list-price.interface";
import { ListPriceMessages } from "@/messages/listPrice/list-price.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ListPriceTableRow } from "./row";
import { LIST_PRICE_TABLE_COLUMNS } from "../../constants";

interface ListPriceTableProps {
  data: PaginatedResponse<IListPrice>;
  pagination: Pagination;
  messages: ListPriceMessages;
}

export function ListPriceTable({ data, pagination, messages }: ListPriceTableProps) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {LIST_PRICE_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items.map((listPrice, index) => (
              <ListPriceTableRow
                key={`${index} - ${listPrice.code}`}
                listPrice={listPrice}
                index={index}
                messages={messages}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
